<p-dialog

  (onHide)="closeDialog()"
  [dismissableMask]="false"
  position="top"
  [contentStyle]="{'overflow':'visible'}"
  [(visible)]="displayDialog"
  [responsive]="true"
  showEffect="fade"
  [style]="{'width':'1000px'}"
  [modal]="true"
  appendTo="body"
>

  <ng-template pTemplate="header">
    <div class="p-dialog-title">
      <i class="fas fa-sign-in-alt mg-r-5"></i> Modifier le mouvement
    </div>
  </ng-template>

  <ng-container *ngIf="!utils.isNullOrEmpty(selectedStockMvt)">

    <form [formGroup]="form">
      <!--ROW1-->
      <div class="dialog-line">

        <div class="dialog-line">
          <div class="col-md-4 genlabel">Nom Denrée</div>
          <div class="col-md-8"><strong>{{selectedStockMvt.denominationArticle}}</strong></div>
        </div>

        <div class="dialog-line">
          <div class="col-md-4 genlabel required" title="Quantité">Quantité</div>
          <div class="p-inputgroup input-group-sm ">
            <input pInputText pKeyFilter="pnum"
                   [style.width.px]="80"
                   (keydown)="utils.keydownNumber($event,form,'quantite',true)"
                   formControlName="quantite"
                   class=" text-right bold">
            <span id="qte" class="p-inputgroup-addon"
                  *ngIf="selectedStockMvt.uniteDeStockage && selectedStockMvt.uniteDeStockage != ''">{{selectedStockMvt.uniteDeStockage}}</span>
            <ng-container
              *ngTemplateOutlet="tplError;context:{form:form,property:'quantite',label:'quantité'}"></ng-container>
          </div>
        </div>

      </div>

      <!--ROW2-->
      <div class="dialog-line">

        <div class="dialog-line">
          <div class="col-md-4 genlabel">Motif</div>
          <div class="col-md-1">
            <ng-container *ngTemplateOutlet="tplEntreeSortie;context:{rowData:this.selectedStockMvt}"></ng-container>
          </div>
          <div class="col-md-7"><strong>{{selectedStockMvt.stockMouvementStatutLibelle}}</strong></div>
        </div>
        <div class="dialog-line" *ngIf="!selectedStockMvt.entreeSortie"></div>
        <div class="dialog-line" *ngIf="selectedStockMvt.entreeSortie">
            <div class="genlabel required" title="Prix">Prix unitaire</div>
            <div class="col-md-8 p-inputgroup input-group-sm ">
              <input pInputText pKeyFilter="pnum"
                     [style.width.px]="80"
                     min="0"
                     (keydown)="utils.keydownNumber($event,form,'prixUnitaire',true)"
                     formControlName="prixUnitaire"
                     class=" text-right bold">
              <ng-container
                *ngTemplateOutlet="tplError;context:{form:form,property:'prixUnitaire',label:'prix unitaire'}"></ng-container>
            </div>
          </div>
      </div>

      <!--ROW3-->
      <div class="dialog-line">

        <div class="dialog-line">
          <div class="col-md-4 genlabel">Remarque</div>
          <div class=" col-md-8 p-inputgroup input-group-sm ">
              <textarea pInputTextarea style="width:100%;height:80px;"
                        formControlName="remarque"
              ></textarea>
              <ng-container
              *ngTemplateOutlet="tplError;context:{form:form,property:'remarque',label:'Remarque'}"></ng-container>
          </div>
        </div>

        <div class="dialog-line">
          <div class="col-md-4 genlabel required">Date de mouvement</div>
          <div class="col-md-8">
            <p-calendar
              firstDayOfWeek="1"
              dateFormat="DD d MM yy"


              [style]="{'font-weight':'bold'}"
              [readonlyInput]="true"
              formControlName="dateMouvement"
              [locale]="localeFr"
              [showIcon]="true"
              [showWeek]="true">
            </p-calendar>
            <ng-container
              *ngTemplateOutlet="tplError;context:{form:form,property:'dateMouvement',label:'date de mouvement'}"></ng-container>
          </div>
        </div>
      </div>
    </form>

  </ng-container>

  <ng-template pTemplate="footer">

    <span class="mg-r-5">
      <yo-button iconClass="fas fa-sign-out-alt" (onClick)="modifierMouvement()"
                 tooltip="Modifier le mouvement"
                 label="Modifier le mouvement"
      ></yo-button>
    </span>
    <span class="mg-r-5">
      <yo-button iconClass="fas fa-times"
                 buttonClass="cta-inner-delete"
                 (onClick)="closeDialog()" tooltip="Annuler" label="Annuler"></yo-button>
    </span>

  </ng-template>

</p-dialog>

<ng-template #tplError let-form="form" let-property="property" let-label="label" let-site="site">
  <div class="error"
       *ngIf="form.controls[property].invalid && (form.controls[property].dirty || form.controls[property].touched )">

    <pre>{{form.controls[property].validators | json}}</pre>

    <div class="pg-2" *ngIf="form.controls[property].hasError('required')">
      {{startError(label)}} est obligatoire.
    </div>
    <div class="pg-2" *ngIf="form.controls[property].hasError('minlength')">
      {{startError(label)}} ne peut avoir moins de {{form.controls[property].errors.minlength}} caractères.
    </div>
    <div class="pg-2" *ngIf="form.controls[property].hasError('aucunparamzds')">
      {{startError(label)}} est obligatoire. Veuillez paramétrer les zones de stockage de l'unité de
      production {{site.libelle | uppercase}}.
    </div>
    <div class="pg-2" *ngIf="form.controls[property].hasError('maxlength')">
      {{startError(label)}} ne peut dépasser {{form.controls[property].errors.maxlength}} caractères.
    </div>
    <div class="pg-2" *ngIf="form.controls[property].hasError('min')">
      {{startError(label)}} doit être supérieur ou égal à {{form.controls[property].errors.min.min}}.
    </div>
    <div class="pg-2" *ngIf="form.controls[property].hasError('max')">
      {{startError(label)}} doit être inférieur ou égal à {{form.controls[property].errors.max.max}}.
    </div>

  </div>

</ng-template>

<!--TEMPLATE ENTREE / SORTIE-->
<ng-template #tplEntreeSortie let-rowData="rowData">

  <ng-container *ngIf="rowData.entreeSortie">
    <i class="fas fa-arrow-right bold mg-l-5 mg-r-5 new-color" title="Entrée de stock"
       ></i>
  </ng-container>

  <ng-container *ngIf="!rowData.entreeSortie">
    <i class="fas fa-arrow-left bold  mg-l-5 mg-r-5 danger-color" title="Sortie de stock"
       ></i>
  </ng-container>

</ng-template>
